import React, { useEffect } from 'react'
import Footer from '../Footer'
import Header from '../Header'
import { Outlet, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LOGIN_ROUTE } from '../../Routes'
import Aside from './Aside'
import { fetchUser } from '../../services/userService'
import { logout } from '../../redux/features/authSlice'
import Loader from '../Loader'
import { ToastContainer } from 'react-toastify'

const LayoutUser = () => {
const dispatch = useDispatch();
const {loader} = useSelector((state) => state.auth);

const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
      if (token){
        dispatch(fetchUser())
      }else {
        dispatch(logout())
        navigate(LOGIN_ROUTE)
      }
  }, [dispatch, navigate]);

  if (loader) return <Loader />

  return (
    <>
    <Header />
    <div className='relative'> 
        <Aside/>
        <div className="p-4 pt-16 sm:ml-64 relative">
        <ToastContainer />
        <Outlet />
        </div>
    </div>
    <Footer />
    </>
  )
}

export default LayoutUser